import { useState } from 'react'

import { isSet } from 'lodash'
import PropTypes from 'prop-types'

import { ConfirmationDialog, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

const OrganizationUserRemoveDialog = ({
  currentOrganizationUser,
  open,
  setOpen = () => {},
  refresh = () => {},
}) => {
  const snackbar = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)

  const noticeText = () => {
    if (!currentOrganizationUser) return

    if (isSet(currentOrganizationUser?.id)) {
      return `Você tem certeza que deseja desvincular o usuário 
            ${currentOrganizationUser?.user?.name} 
            do Grupo Advisor ${currentOrganizationUser?.organization?.name}? 
            Após confirmar, esse usuário não terá mais acesso ao grupo.`
    }

    return `Você tem certeza que deseja desvincular o usuário do 
            Grupo Advisor ${currentOrganizationUser?.organization?.name}?`
  }

  const onSubmit = async (currentOrganizationUser) => {
    try {
      setIsLoading(true)
      await service.backoffice.organizationUsers.destroy({
        organizationId: currentOrganizationUser?.organization?.id,
        id: currentOrganizationUser?.id,
      })

      refresh()

      snackbar.open({
        message: 'Usuário foi desvinculado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao desvincular usuário!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpen(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <ConfirmationDialog
        open={open}
        setOpen={setOpen}
        message={noticeText()}
        buttonText="Confirmar"
        actionAcceptButton={() => onSubmit(currentOrganizationUser)}
      />
    </>
  )
}

OrganizationUserRemoveDialog.propType = {
  currentOrganizationUser: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
  setNewOrganizationUsers: PropTypes.func,
}

export default OrganizationUserRemoveDialog
